export default "__VITE_ASSET__CZf5NQJH__"